export const ORGANIZATION_SYNC_WARNING_KEY = "organization_sync_warning";
export const ORGANIZATION_SYNC_STARTED_AT_KEY = "organization_sync_started_at";
export const ORGANIZATION_SYNC_WARNING_EVENT = "organization-sync-warning";

const CUSTOMER_CACHE_REFRESH_WINDOW_MS = 2 * 60 * 1000;
export const CUSTOMER_CACHE_REFRESH_INTERVAL_MS = 5 * 1000;

export const isCustomerSyncWindowActive = () => {
  const startedAt = Number(sessionStorage.getItem(ORGANIZATION_SYNC_STARTED_AT_KEY));
  return Number.isFinite(startedAt)
    && startedAt > 0
    && Date.now() - startedAt < CUSTOMER_CACHE_REFRESH_WINDOW_MS;
};
